import React from 'react'
import { cn } from '@strata-monorepo/shared-ui/utils/cn'
import Phone from '@strata-monorepo/shared-ui/images/icons/Phone'
import { useStoreState } from '../../store/useStore'
import { FuseNumber } from '../FuseNumber/FuseNumber'

interface CallButtonProps {
  text?: string
  /** On mobile, show this label and hide the formatted number until the md breakpoint. */
  mobileShortLabel?: string
  /** Whether the viewport is mobile-sized. Required when mobileShortLabel is provided. */
  isMobile?: boolean
  trackingLocation: string
  className?: string
  additionalClasses?: string
  /** Render a phone icon before the label/number. */
  showIcon?: boolean
  iconClassName?: string
  handleOnClick?: () => void
  trackingName?: string
  trackingPosition?: string
}

export function CallButton({
  text = 'Call Now:',
  mobileShortLabel,
  isMobile = false,
  trackingLocation,
  className = '',
  additionalClasses = '',
  showIcon = false,
  iconClassName = '',
  handleOnClick,
  trackingName = '',
  trackingPosition,
}: CallButtonProps): React.ReactElement | null {
  const { bannerFuseConfig } = useStoreState((state) => state.phoneConfig)

  if (!bannerFuseConfig) {
    return null
  }

  const displayText = mobileShortLabel !== undefined && isMobile ? mobileShortLabel : text

  return (
    <FuseNumber
      testid='callButton'
      numberClasses={cn(
        'strata:font-medium strata:rounded-xs strata:py-2 strata:px-4 strata:cursor-pointer strata:inline-flex strata:items-center strata:gap-1',
        className,
      )}
      numberDisplayClasses={cn(
        additionalClasses,
        mobileShortLabel !== undefined && 'strata:hidden strata:@md:inline',
      )}
      leadingContent={
        <>
          {showIcon ? (
            <Phone classNames={cn('strata:h-4 strata:w-4 strata:shrink-0', iconClassName)} />
          ) : null}
          {displayText ? <span>{displayText}</span> : null}
        </>
      }
      onClick={handleOnClick}
      fuseName={bannerFuseConfig.name}
      permalease={bannerFuseConfig.dnis}
      trackingLocation={trackingLocation}
      trackingName={trackingName}
      trackingPosition={trackingPosition}
    />
  )
}

export default CallButton
